import React from 'react'
import Loads from './Loads'
import { useLoadStates } from '../Shared/hooks'

const ProjectLoads = props => {
  const { currentProjectLoads, currentProjectName, activeData } = props
  const loadStates = useLoadStates()
  const { updateMaterial, enterMaterial } = loadStates

  return (
    <div>
      <div>
        <span style={{ ccoclor: '#6B6C70', fontSize: '16px' }}>
          {updateMaterial ? 'Update Material' : 'Project ' + currentProjectName}
        </span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0 24px' }}>
        <span style={{ fontSize: '24px', color: '#3E3F42', fontWeight: '500' }}>
          {updateMaterial
            ? enterMaterial
              ? 'Enter material '
              : 'Select Loads'
            : currentProjectName}
        </span>
      </div>

      <Loads
        currentItemSelectedLoads={currentProjectLoads}
        {...loadStates}
        activeData={activeData}
      />
    </div>
  )
}

export default ProjectLoads
